export default {
  msg: {
    //countdown / time
    seconds: `Seconds`,
    minutes: `Minutes`,
    hours: `Hours`,
    days: `Days`,

    //titles / sub
    insights: "Insights",
    fund_holdings: "Holdings",
    charity_sub: "Stratum has donated the following to charity.",
    network_distributions: "Network distributions",
    network_distributions_sub:
      "Coins earned on network distributions such as airdrops.",
    redemption_sub: `Operation to liquidate BLUE, and receive the equivalent value in dollar-pegged stablecoin Tether (USDT).`,
    twofa_info: "To redeem, you must enable 2FA.",
    redemption_sub_one:
      "Redemptions are available on Wednesdays, from 0h to 17h (UTC -3), and will take 3 business days to credit (D+3).",
    redemption_sub_two: "A same-day payment option is available for a fee.",
    redemption_sub_three:
      "Redemptions are paid using the Tron network (TRC-20).",

    //a
    alert_created_deposit:
      "Your wallet has already been created, please refresh the page.",
    alert: "Alert",
    asset_allocation: "Cryptocurrency Allocation",
    amount_below_purchase_limit: "Amount below minimum purchase limit",
    amount_below_minimum_trade_limit: "Amount below minimum trade limit",
    activating_account: "Please wait. Activating account...",
    activation_successful:
      "Congratulations, your account is now active. You may login now.",
    activation_successful_2fa:
      "Congratulations, your 2fa code now active. You may proceed to services.",
    activation_link_invalid: "Activation link is invalid",
    apply_filter: "Apply filter",
    add_funds: "Add BLUE",
    address: "Address",
    actions: "Actions",
    action: "Action",
    all: "All",
    all_rights_reserved: "All rights reserved",
    all_transactions: "View all",
    already_member: "Already a member?",
    amount: "Amount",
    approx_value: "Approximated value",
    equivalent_in: `Equivalent in`,
    one_blu_equals: `1 BLUE equals`,
    equivalence: "Equivalence",
    one_blu: "1 BLUE",
    updated_last: "Updated last",
    all_time: "All times",
    activate: "Activate",
    available_info: "Available for redemption",
    available_to_redeem: "Due to high demand on redemptions, and the current amount of funds locked on exchanges, this redemption will pass our feasible redemption liquidity threshold for this week.  Please try a lower amount, or try  your redemption again next week.",
    available: "Available",
    attention_done: "Attention: Your order has been done",
    attention_cancel:
      "Attention: Your order has been canceled. If you wish to purchase BLUE, please open a new order",
    attention_waiting_days:
      "Attention: Your order has {hours} until expiration.",
    attention_waiting_hours:
      "Attention: Your order has {hours} hours until expiration.",
    attention: "Attention",
    available_balance: "Available Balance: ",
    allocation: "Allocation",
    authenticate: "Authenticate",
    address_empty: "Address is empty",
    average_time: "Deposits may take up to 5 minutes.",

    //b
    balance: "Balance | Balances",
    begins: "Begins",
    bonus: "Bonus",
    buy: "Buy",
    buy_tokens: "Buy BLUE",
    buyer_bonus: "Buyer bonus",
    blank: "",
    bonus_0dot5: "Bonus(0.5%)",
    bonus_1: "Bonus(1%)",
    buy_here: "Buy Here",
    buy_now: "Buy Now",
    bktc: "BKTC",
    back: "Back",
    balance_equivalence: "Balance equivalence in",
    buy_pix: "Buy BLUE with PIX",
    buy_pix_info:
      "Using SWAPiX, a trusted partner offering fiat-to-crypto exchanges.",
    blue_club_status: "Blue Club Status",

    balance_text_tusd: "TrueUSD Stablecoin pegged to the American Dollar",
    balance_text_btc: "Bitcoin",
    balance_text_rlt: "RealT Stablecoin pegged to the Brazilian Real",
    balance_text_eth: "Ethereum",
    buy_token: "BUY TOKEN",
    boleto: "Boleto",
    best_way_buy: "Best way to buy",
    browser_message:
      "If you cannot see the document, please use Firefox or Safari.",
    business_day: "BUSINESS DAYS",
    no_additional_fee: "No additional fees.",
    rush_today: "RUSH (Today)",
    receive_today_info: "You will receive in the same calendar day.",
    basket_value: "Basket Value",

    //c
    charity: `Charity`,
    clear_filter: "Clear filter",
    cancelled: "Cancelled",
    cancel_purchase: `Cancel Purchase`,
    click_on_transaction_to_get_details: `Click on a transaction for more details.`,
    chart: "Chart",
    crypto: "Crypto",
    copy_twofa:
      "Scan the QR code with your cell phone using Google Authenticator or Authy, or type the code.<strong>Keep this code in a safe place in case you lose your phone, and do not share with anyone. You can recover your 2FA using this code.</strong>",
    confirm_delet: "Are you sure?",
    click_here: "Access smartwallet",
    confirm_redeem: "Your redemption is being processed.",
    confirm_withdraw: "Your withdraw is being processed.",
    amount_revice_withdraw: "Amount to receive",
    amount_revice_withdraw_fee: "Fee: ",
    confirm_internal: "Your internal transfer is being processed.",
    can_not_load_data: "Cannot load data.",
    change: "Change",
    coin_slider_BTC: "Bitcoin",
    coin_slider_RAS: "Ras - Stablecoin paired to Brazilian Real",
    coin_slider_BLU: "TrueUSD - Stablecoin paired to American Dollar",
    coin_slider_ETH: "Ethereum",
    coin_slider_ZAR: "RAND - South Africa currency",
    coin_slider_EUR: "Euro - European Union currency",
    coin_slider_GBP: "Pound Sterling - United Kingdom currency",
    coin_slider_CHF: "Swiss Franc - Switzerland currency",
    coin_slider_CNY: "Yuan - Chinese currency",
    coin_slider_CAD: "CA$ - Canadian currency",
    coin_slider_AUD: "A$ - Australian currency",
    coin_slider_HKD: "HK$ - Hong Kong Dollar currency",
    coin_slider_USDT: "USDT - Stablecoin paired to American Dollar",
    cancel: "Cancel",
    contact_us_any_question:
      "Please feel free to contact us at support@bluetoken.io for any questions.",
    cellphone: "Cellphone",
    cpf: "CPF",
    cep: "CEP",
    complement: "Complement",
    city: "City",
    criptocurrency: "Cryptocurrency",
    chose_two_coins: "Return shown is year-to-date, until December 23rd 2022.",
    click_here_to_vote: "Click here to vote",
    copy_address: "Copy Address",
    create_order: "Create new order",
    cancel_transaction: "Cancel transaction",
    canceling_order: "Cancelled order",
    canceling: "Cancelled",
    checking_open_orders: "Checking open orders",
    copy_alert_info_otc: "Copied - expected amount and estimated amount",
    confirm_recaptcha: "Confirm the CAPTCHA",
    create_deposit_address: "Create deposit address",
    check_info_redeem:
      "I have verified that the above information is accurate.",
    current_value: "Current Value",
    component_hold: "Component",
    current_weight: "Current Weight",
    currently_generating: "Currently generating daily rewards",
    country_residency: "Country of Residency",
    countries_not_allowed:
      "USA/China/HK - Countries not allowed to use our services!",
    clain_your_nft: "Claim your NFT",

    //check
    check_your_email: "Please check your email and follow the instructions.",
    check_your_email_for_userid: "You will receive an email with your User ID.",
    check_your_email_for_recovery_link:
      "You will receive an email with a recovery link.",
    check_your_email_for_pin:
      "You will receive an email with the PIN to confirm the transaction",
    check_your_email_for_pin_redeem:
      "You will receive an email with the PIN to confirm the transaction",
    if_no_email_spam: `If you cannot find the email, please check your Spam box.`,
    closes: "Closes",
    component: "Component | Components",
    confirm: "Confirm",
    confirm_operation: "Confirm Operation",
    confirmation_pin: "Confirm Your Pin",
    confirmation_pin_email_hint:
      "Upon continuation you will receive an email with a confirmation pin, required to complete your operation.",
    contact: "Contact",
    continue: "Continue",
    copied: "Copied",
    copy: "Copy",
    currency: "Currency",
    click_here_action: "click here",
    change_withdraw_partner: "To change withdraw partner,",

    //d
    denied: "Denied",
    dashboard: "Dashboard",
    dont_have_btc: `Don't have Bitcoin?`,
    details: "Details",
    deposits: "Deposits",
    deposit_amount: "Deposit Amount",
    dear_blu_holder: "Dear BLUE holder",
    district: "District",
    donwload: "Donwload",
    documentation_info: "Fact sheets, methods, calculation and other documents",
    dropdown_header_withdraw: "Send your tokens to an external wallet",
    dropdown_header_deposit: "Receive your tokens from an external wallet",
    dropdown_header_redeem: "Exchange your tokens",
    dropdown_header_internal: "Send BLUE to another user",
    destination_user: "Destination user",
    deposit_received: "Your deposit has been received",
    do_you_want: "Do you want to cancel anyway?",
    download_pdf: "Download PDF",
    blue_team: "BLUE Team",
    deposit_sub:
      "Deposit is an operation that allows you to receive {coin} from an external wallet.",
    delivery_speed: "Delivery Speed",
    download_csv: "Download CSV",

    //dates
    date_1: "December 4th, 2018",
    date_2: "January 15th, 2019",
    date_3: "January 16th, 2019",
    date_4: "February 15th, 2019",
    date_5: "February 16th, 2019",
    date_6: "April 6th, 2019",
    date_7: "April 11th, 2019",

    days_remaining: "Days remaining",
    deposit: "Deposit",
    disclaimer: "Disclaimer",
    documentation: "Documentation",

    //e
    expire_in: "Expire at",
    expired: "Expired",
    earn_on_referrals: "Earn on referrals",
    earn_bonus_tooltip: "Bonus earned from referral program.",
    email: "Email",
    equals: "Equals",
    export_csv: "Export CSV",
    ends: "Ends",
    explorer: "Explorer",
    equivalent: "Equivalent",
    equivalent_to: "Equivalent to",
    expired_pin: "Expired pin",
    enable_2fa: "Enable 2FA",
    eth_contract_message: "Do not send Ether using a Smart Contract",
    clicl_expand: "Click to expand",
    expand_chart: "Expand Chart",
    estimated_info_modal_equivalent:
      "Estimated value based on Tether exchange with other currencies",

    //error_message
    error: "Error",
    error_create_address: "Error to create the address, try later",
    error_redeem: "There was an error with your request.",
    error_redeem_amount:
      "Make sure that you have enough balance available and that the amount requested is above the minimum.",
    error_redeem_amount_no_funds:
      "You don't have enough unlocked funds to perform this operation",
    error_redeem_amount_below_min:
      "The amount MUST be above the minimum required.",
    error_redeem_address: "Make sure to use a valid BTC address.",
    error_withdraw_address: "Make sure to use a valid BLUE address.",
    error_redeem_confirm: "An error occurred, check the fields.",
    error_internal_member_not_found: "User ID not found",
    error_pool_avatar: "Avatar already exists.",
    error_pool_avatar_select: "You need to choose an avatar name and icon.",

    //f
    faq: "FAQ",
    fee: "Fee | Fees",
    fees_minimums: "Fees & Minimums",
    forgot_password: "Forgot password",
    forgot_userid: "Forgot User ID",

    fee_1dot5: "Fee 1.5%",
    fee_2dot5: "Fee 2.5%",
    fee_4: "Fee 4%",
    fee_6: "Fee 6%",
    fees_minimum_amount: "Fee is 2 USDT of amount, with a minimun of 2 USDT",
    fund_in_maintenance:
      "Our system is currently under maintenance, please try your operation at a later time.",
    fill_form_boleto: "Fill the form to generate a Boleto",
    fill_form: "Fill the form",
    fact_sheet: "Fact Sheet",
    finish_Vote: "Finish vote",
    finish: "Finish",
    form_error_fields: "All fields are required!",
    found_member: "Found Member",
    fee_info_redeem_one: "Fee is",
    fee_info_redeem_two: "of amount, with a minimum of",
    fee_redeem_wave_info: "Fee is 2 USDT for redemptions below 50 USDT.",
    error_xgateway:
      "Our network is currently experiencing issues with the selected crypto. Please try again in a few minutes.",

    //g
    get_pin: "Get pin",
    global_search: "Global search",
    generate_slips: "Generate Boleto",
    g_l: "G/L",
    generating_tokens: "Generating tokens, please wait",

    //h
    help: "Help",
    history: "History",
    hypothetical_portfolio: `Hypothetical components subject to change.`,
    home: "Home",
    here: "here",
    how_vote: "How to vote?",
    header_referral: "Did someone refer you?",
    how_it_works:
      "<a href=https://youtu.be/NujOX3n7d-g target=_blank>How does it work?</a>",

    //i
    input_usdt_address: "Input USDT address",
    input_blue_amount: "Input BLUE amount",
    input_amount_redeem: "Input the amount of BLUE you wish to redeem.",
    input_amount_withdraw: "Input the amount of BLUE you wish to withdraw.",
    input_amount_transfer:
      "Input the amount of BLUE you wish to transfer to another account",
    info_redeem_step_3: "For your safety, enter the PIN and 2fa.",
    info_redeem_address_step_4: "Address: ",
    info_redeem_email_step_4: "You will receive all the details in your email.",
    info_redeem_step_4: "The process will be completed today.",
    info_redeem_step_5: "The process will take 3 business days.",
    info_withdraw_step_4:
      "Wait until your transaction is processed by the blockchain.",
    info_2fa_tip:
      "As a security measure, you must first enable 2FA to transfer or redeem your tokens.",
    inform_the_amount_bitcoin_address:
      "Inform the amount and your Bitcoin address",
    inform_the_amount_blu_tag: "Input the amount and BLUE address",
    inform_the_amount_user_id: "Inform the BLUE amount and User ID",
    internal: "Internal transfer",
    internal_sub:
      "Internal Transfer is an operation that allows you to send BLUE to another user within the BLUE platform.",
    internal_steps: "Internal  Transfer steps",
    internal_action_send: "Sent",
    internal_action_receive: "Received",
    info_usdt_blue_purchase:
      "Send only USDT to this address. You must use the Tron Network (TRC20).",
    input_valid_usdt: "Input a valid Tether (USDT) TRC20 Address",
    send_to_my_usdt: "Send to my Tether wallet",
    usdt_info_trc20:
      "We use Tron`s TRC20 network. Make sure you only input a TRC20 address.",
    input_text_USDT: "Input the amount and USDT Address",
    input_text_invalid_USDT: "Input the amount of USDT you wish to withdraw.",

    //insert
    insert_bitcoin_address: "Insert Bitcoin Address",
    insert_quantity: "Insert quantity",
    insert_your_pin: "Insert your pin",

    //invalid
    invalid_address: "Invalid Address",
    invalid_amount: "Invalid amount",
    invalid_credentials: "Invalid credentials.",
    invalid_destination_address: "Invalid destination address.",
    invalid_phone: "Invalid phone",
    invalid_phone_country: "Country not allowed to use our services.",
    invalid_email: "Invalid email.",
    invalid_has_accepted_terms: "Please accept the Terms & Conditions.",
    invalid_is_aware_token_redemption: "Please check the checkbox above.",
    invalid_input_amount_crypto: "Invalid amount",
    invalid_is_not_usa_citizen:
      "Confirm that you are not a citizen or resident of the United States.",
    invalid_is_not_china_citizen:
      "Confirm that you are not a citizen or resident of Hong Kong.",
    invalid_password: "Invalid password.",
    invalid_password_confirmation: "Invalid password confirmation.",
    invalid_password_old: "Invalid current password",
    invalid_pin: "Invalid PIN.",
    invalid_referral_code: "Invalid referral code.",
    invalid_userid: "Invalid user ID.",
    invalid_user_id: "Invalid user ID.",
    invalid_connetion:
      "There was a problem authenticating your request, check your connection or your user.",
    invalid_2fa_code: "Incorrect 2fa code",
    insert_referral_code: "Insert referral code (Optional)",
    invalid_has_accepted_privacy_policy: "Please accept the Privacy policy",
    Invalidaddress: "This address is not accepted.",

    //l
    language: "Language | Languages",
    launch: "Launch",
    launch_april: "Launch - APRIL 2019",
    legal: "Legal",
    list: "List",
    last_update: "Last update",
    link_no_account: `If don't have a Stratum account yet, <a href="https://auth.stratum.hk/signup.php?lang=en" target="_blank"> click here </a> to create one.`,
    loading_balance: "Loading account balance...",
    live_price: "Live Price",
    last_month_blue_total: "Blue Pool paid a total of",

    //languages
    en: "EN | English",
    es: "ES | Spanish",
    pt: "PT | Portuguese",

    loading: "Loading",
    loading_data: "Loading Purchase Data",
    load_fee: "Load Fee",
    login: "Login",
    login_successful: "Logged in successfully",
    login_here: "Login Here",
    logout: "Logout",
    latest: "Latest",

    //m
    minimum: "Minimum",
    money: "money",
    masternodes: "masternodes",
    make_new_redeem: "Make a new redemption",
    methodology: "Methodology",
    min_amount_is: `The minimum amount is`,
    member_not_found: "Member not found.",
    make_sure_address: "Make sure to use a valid BLUE address.",
    my_balances: "My Balances",
    my_balance: "My Balance",
    my_total_value: "My Total Value",
    my_gain_loss: "My Gain/Loss",
    minimum_purchase_USDT:
      "Minimum required balance is 20 USDT. Please increase your balance.",
    minting: "Minting",
    member_benefits: "Membership Benefits",
    my: "My",

    //n
    name: "Name",
    name_optional: "Name (Optional)",
    next: "Próximo | Prox",
    no_data_found: "No data found",
    no_rec_transactions_found: "No transactions found.",
    not_enough_balance: "Not enough balance",
    not_member_yet: "Not a member yet?",
    next_step: "Next step",
    number: "Number",
    no: "No",
    network: "Network",
    notification: "Notification",
    only_one_day: "Only 1 redemption per day allowed.",

    //o
    of: "of",
    opens: "Opens",
    open_account: "Open Account",
    operations: "operations",
    Operations: "Operations",
    or: "or",
    one_token_equivalence: "One BLUE equivalence in",
    optional: "Optional",
    otc_info:
      "Please provide the information below. Our OTC desk will get in touch to assist you with your purchase.",
    otc_thank_msg: "Our OTC Desk will contact you shortly.",
    otc_purcahse_info: "Purchase Information",
    otc_purcahse: "OTC Purchase",
    otc_purchase_info_to_user:
      "Your purchase is being processed by our OTC Desk, please wait.",

    //p
    past_2fa: "Input here the 2FA code with 6 digits",
    pin_already_been_used: "Pin already been used",
    price_graph: "Price Graph",
    portfolio_value: "Crypto-basket Value",
    pay_slip_info: "Pay the boleto to receive your BLUEs",
    purchase_information: "Purchase information",
    please_chose_two_coins: "Please choose 2 cryptocurrencies.",
    phone_optional: "Phone",
    phone_code: "Country Code",
    phone: "Phone",
    purchase_seller_to_user: "Purchase BLUE for other user?",
    purchase_success: "Your purchase have been created for the user.",
    price_history_list: "Price History",
    closing_price: "Closing Price",
    pay_with_USDT: "Pay with USDT balance",

    //password
    change_password: "Change password",
    current_password: "Current Password",
    confirm_password: "Confirm password",
    new_password: "New Password",
    password: "Password",
    password_create: "Create new password",
    password_changed: "Password has been changed",
    password_requirements:
      "Password must contain at least 8 characters, 1 special character (-_+=,<.>;:^~@#$%&*), 1 lower case letter, 1 capitalized letter and 1 number.",
    recover_password: "Recover Password",
    recover_userid: "Recover User ID",
    password_suggestion: "Use Blue suggested password",
    confirm_password_error: "Confirm your password change.",
    wrong_password_confirmation: "Wrong password confirmation",
    phone_already_registered: "This phone is already registered.",
    email_already_registered: "This email is already registered.",

    pay_with: "Pay with crypto",
    perc_portfolio: "% of Crypto-basket allocation",
    phase: "Phase | Phases",
    portfolio: "Crypto-basket",
    price: "Price",
    pre_sale: "Pre-Sale",
    preferences: "Preferences",
    preferred_language: "Preferred language",
    previous: "Previous | Prev",
    privacy_policy: "Privacy Policy",
    purchase: "Purchase",
    performance: "Price Evolution",
    please_verify_information:
      "Please verify the information below is accurate.",

    //q
    quantity: "Quantity",

    //r
    receive_calculator_text: `Calculation excludes any fees imposed by your own wallet and the network. We advise to deposit a bit more than the desired amount.`,
    receive: "Receive",
    receiving_email: "Receiving email",
    recent_transactions: "Recent transactions",
    redeem: "Redeem",
    referral_award: "Referral Award",
    referrals: "Referrals",
    referral_code: "Referral code",
    report: "Quarterly Report",
    report_link_text: "Launch",
    report_link_download_quarter:
      "Download the quarterly report October - December 2022 (Q4 2022)",
    report_link_span: "Reports are posted the first week of every quarter.",
    redemptions: "Redemptions",
    redemption: "Redemption",
    redemption_info:
      "<strong>Fee-less redemptions:</strong> You qualify to redeem up to <strong>50 BLUES</strong> without a fee. Amount must be worth over <strong>1000 TUSD</strong>.",
    redeem_pin: "Input PIN",
    redeem_2fa: "Input 2FA",
    redeem_not_allowed_today:
      "Redemptions are available Wednesdays, from 00h to 17h (UTC -3).",
    redeem_not_allowed_today_1:
      "Redemptions are not available today. Please refer to the redemption schedule.",
    redeem_not_allowed_today_2:
      "Redemptions are available Tuesday, from 00h to 17h (UTC -3).",
    redeem_not_allowed_today_3:
      "Redemptions are available Wednesdays, from 00h to 17h (UTC -3).",
    redeem_not_allowed_today_4:
      "Redemptions are available Thursday, from 00h to 17h (UTC -3).",
    redeem_not_allowed_today_5:
      "Redemptions are available Friday, from 00h to 17h (UTC -3).",
    redeem_not_allowed_today_6:
      "Redemptions are available Saturday, from 00h to 17h (UTC -3).",
    redeem_not_allowed_today_7:
      "Redemptions are available Sunday, from 00h to 17h (UTC -3).",
    redeem_deleted_success: "Redemption canceled successfully!",
    redeem_deleted_error: "Something wrong, try again later.",
    reedeem_2fa_text: `
            <p>What is 2FA and why should I use?</p>
            <p>2FA stands for 2 Factor Authentication. It protects your account by combining something that you know (your password) with something that you have (like your cellphone or security key).</p>
            <p>After setting up 2FA on your phone, you will see an access code that changes constantly. You must use the 2FA access code every time you redeem tokens; however, you only have to install 2FA once.</p>
            <p>In case you do not have an authenticator yet, please proceed to use one of the below:</p>
            <a href="https://www.google.com/landing/2step/#tab=how-it-works" target="_blank">Google Authenticator</a>
            <a href=" https://authy.com/download/" target="_blank">Authy Authenticator</a>
        `,
    tutorial_tittle: `<p style="color:#424b7d">How to Deposit {coin}?</p>`,
    tutorial_deposit: `
        <p>1. Create a BLUE deposit address;</p>
        <p>2. Locate the "SEND" form on the external wallet;</p>
        <p>3. Scan or copy the Blue token address into that form.</p><br/>
        <b>Note:</b>
        <span>BLUE deposits ara charged a 6% network fee, paid by the sender. <a href="https://bluetoken.io/fees" target="_blank" style="margin-top:0px; display: contents;">Fees.</a></span>
    `,
    tutorial_deposit_usdt: `
    <p>1. Create a Tether (USDT) deposit address;</p>
    <p>2. Locate the "SEND" form on the external wallet;</p>
    <p>3. Scan or copy the Tether (USDT) address into that form.</p><br/>
    <b>Note:</b>
    <span>Make sure you select Tron (TRC20) network.</span>
`,
    tutorial_tittle_withdraw: `<p style="color:#424b7d">How to add the Blue Token in external wallets?</p>`,
    tutorial_withdraw: `
        <p>1. Select Binance Smart Chain (BSC) on the external wallet network;</p>
        <p>2. Copy this Blue token contract address and import on the external wallet;</p>
    `,
    tutorial_withdraw_pt2: `
        <b>Note:</b>
        <p>- Blue Token does not assume responsibility for operations occurring on third party platforms.</p>
        <p>- All transactions originating outside our platform are charged a 6% network fee. <a href="https://bluetoken.io/fees" target="_blank" style="margin-top:0px; display: contents;">Fees.</a></p>
    `,
    cancel_redeem: `Cancel Redemption`,
    retry: "Retry",
    required_fields: "Required fields",
    recipients_user_id: "Recipient's User ID.",
    staking_rewards: "Recompensas de Staking",
    redeeming: "Redeeming",
    receiving: "Receiving",

    //referral texts
    referral: "Referral",
    referral_text_1:
      "When you refer people to buy BLUE, you get a reward and they get a bonus, paid in BLUE!",
    referral_text_2:
      "Give the referral link or code to your friends and family. Rewards and bonuses are unlimited. No matter how many times your referrals buy BLUE, you will get a reward, and they will get a bonus.",
    referral_text_3:
      "To activate your referral code, first you must purchase BLUEs. Once your purchase BLUEs, come back to this page, and start using your referral code.",
    review_your_purchase: "Review Your Purchase",
    reward: "Reward",
    rows_per_page: "Rows per page",
    redeemed_value: "Redeemed Amount",
    required_fields_amount_uid: "Amount and UID are required for this action.",

    //s
    save: "Save",
    send: "Send",
    settings: "Settings",
    header_settings: "Settings",
    signup: "Sign up",
    something_went_wrong: "Something Went Wrong",
    subtotal: "Subtotal",
    send_to_btc_adress: "Destination Address",
    send_to_btc_adress_destination: "Bitcoin Destination Address",
    send_to_blu_adress: "<strong>BLUE</strong> Destination Address",
    send_to_blu_adress_on: "<strong>BLUE</strong> Destination Address on",
    step_1_withdraw_blue: "1. Select your preferred wallet to Withdraw.",
    allowed_wallets: "*Allowed wallets:",
    step_2_withdraw_blue:
      "2. Click to copy the Blue Token contract address on the Binance Smart Chain:",
    step_3_withdraw_blue:
      '3. Click to automatically import the token from Blue on <a href="https://bit.ly/3wMClbk" target="_blank">Metamask</a>',
    step_3_withdraw_blue_p2:
      "follow the instructions to manually add the token from Blue on:",
    or: "or",
    contract_address: "0xE2F3Db52F7065220e113014f23f5DD4c7bafBAc2",
    success: "Successful",
    success_create_wallet: "Address created successfully",
    session_expired: "Session expired. Please log in again",
    services: "Services",
    staking_APY: "Staking APY",
    submit: "Submit",

    months: {
      1: "January",
      2: "February",
      3: "March",
      4: "April",
      5: "May",
      6: "June",
      7: "July",
      8: "August",
      9: "September",
      10: "October",
      11: "November",
      12: "December"
    },

    //pool
    pool: "Pool",
    join_pool: "Join & Earn",
    monthly_rewards: "{month} Pool Rewards",
    my_rewards: "My Estimated Rewards",
    qualification_status: "Qualification status",
    need_to_qualify: "Need",
    to_qualify: "to qualify",
    calculating: "calculating...",
    posted_soon: "Pool is being calculated and will be posted soon.",
    nobody_qualified:
      "Nobody has qualified yet to earn the pool rewards. Be the first and win!",
    leaderboard: "Leaderboard",
    last_month_winners: "Last month winners",
    referral_volume: "Referral Volume",
    reward_pool: "Reward %",
    estimated_pool: "Estimated",
    earned_pool: "Earned",
    view_all: "View all",
    modal_pool_title: "Blue Pool Rewards",
    modal_pool_text:
      "Every month a pool is created to reward you for your referral's purchases. Participants who accumulate 1 BLUE token or more in referral purchases automatically earn a share of the pool. <a href=https://youtu.be/NujOX3n7d-g target=_blank style='width:auto'>Watch tutorial</a>",
    modal_pool_important: "Important",
    modal_pool_text2: "To participate, you must first create your avatar.",
    modal_pool_text3: "Your avatar cannot be changed in the future.",
    modal_pool_nick: "Create a Nickname",
    modal_pool_nick_span:
      "To protect your privacy. We advise you not to use your real name.",
    modal_pool_avatar: "Select Avatar",
    modal_pool_btn: "JOIN",

    modal_pool_welcome: "Welcome to the Blue Pool",
    modal_pool_span:
      "When your referrals accumulate 1 BLUE in purchases, your avatar will show on the leaderboard, securing a share in the pool.",
    modal_pool_span2: "The more they buy, the bigger your share!",
    modal_pool_referral: "Your referral ID:",
    modal_pool_referral_link: "Your referral link",
    modal_pool_close: "CLOSE",

    street_name: "Street name",
    state: "State",
    select_partner: `Select a partner`,
    skip: "skip",
    start_withdrawal: "Start withdrawal",
    start_internal_transfer: "Start Internal Transfer",
    internal_transfer: "Internal transfer",
    send_exactly: "Send the amount below to the following address:",
    seller_buy:
      "Purchase as the member u want, just need to provide the UID and amount.",
    sector: "Sector",

    //steps_text
    step_amount: "Amount",
    step_recipient: "Recipient",
    step_verification: "Verification",
    step_authentication: "Authentication",

    //status
    status_new: "New",
    status_waiting: "Waiting",
    status_processing: "Processing",
    status_done: "Done",
    status_failed: "Failed",
    status_cancelled: "Cancelled",
    status_denied: "Denied",
    status_expired: "Expired",
    status_queued: "Queued",

    //t
    tag: "tag ID",
    tag_important:
      "Make sure to set the right tag ID to ensure that the amount is sent to your address.",
    terms_and_conditions: "Terms & Conditions",
    tokens_go_on_sale: "BLUEs go on sale",
    token_presale: "Pre-sale",
    token_distribution: "Distribution",
    total: "Total",
    total_debit: "Total Debit",
    total_received: "Total Received",
    total_to_transfer: `Total to send`,
    total_to_pay: `Total to pay`,
    transaction: "Transaction | Transactions",
    transaction_completed: "Transaction Completed",
    transaction_details: "Transaction Details",
    type: "Type",
    token: "Token",
    token_info: "Info",
    token_supply: "Supply",
    token_nav: "NAV",
    fund_value: "Fund Value",
    token_price: "Price",
    transaction_with_wrong_status: "Transaction with incorrect status",
    trade_not_found: "Redemption not found. Start again.",
    transfers: "Transfers",
    total_redeem: "Total in BLUE",
    total_redeem_USDT: "Total in USDT",
    total_plus_block: "Available + blocked",
    token_supply_equivalence: "Token supply equivalence in",
    transaction_failed_step:
      "Transaction failed at step {step}, if you have any questions please contact support at support@bluetoken.io",
    transfer_blu_stx:
      "Send your BLUE tokens to <span class='custom_highlight'>StratumX.io</span>. Use to trade BLUE for other cryptos.",
    transfer_blu_stratum:
      "Send your BLUE tokens to SmartWallet. Use to sell BLUE, pay bills, plus other services.",
    transfer_blu_stratum_withdraw_sw:
      "Send your BLUE tokens to Stratum Advanced Wallet, and enjoy many benefits.",
    tag_text:
      "The TAG is a unique identifier to recognize you and made available by the withdrawal partner. The TAG is located at the partner's wallet deposit page.",
    table_failed_1: "* Incomplete orders",
    table_failed_2: "* All Incomplete orders will automatically be cancelled",
    thank_you: "Thank you",
    thank_you: "Thank you",
    temporarily_unavailable: "Temporarily unavailable.",
    tether_info:
      "Send via the Tron Network (TRC20), or use your available balance.",
    token_type: "Token type",
    today: "Today",
    bep20: "BEP20 (Binance Smart Chain)",
    decentralized_ex: "Decentralized Exchanges (DEX)",
    metaverse: "Metaverse",
    lending: "Lending",
    payments: "Payments",
    native: "Native",
    erc20: "ERC20 (Ethereum)",
    todays_market: "Today´s Market",
    token_supply: "Token Supply",
    smart_contracts: "Smart Contracts",
    scaling: "Scaling",
    tks_your_payment: "Thanks for your payment.",
    wait_create_tokens:
      "Please wait a few minutes while we create your token(s).",

    //tickers
    BLU: "BLUE",
    BTC: "Bitcoin",
    ETH: "Ethereum",
    TUSD: "TrueUSD",

    //transaction tables
    createdAt: "Created At",
    updatedAt: "Updated At",
    status: "Status",
    done: "Completed",
    pre_done: "Completed",
    failed: "Failed",
    new: "New",
    processing: "Processing",
    txid: "TX ID",
    start_date: "Start Date",
    end_date: "End Date",

    //u
    use_all: "Use all",
    userid: "User ID",
    user: "User",
    use: "Use",
    user_id_inportant:
      "Make sure to insert the right User ID to ensure that the amount is sent to the correct account",

    //v
    value: "Value",
    view_all_transactions: "View all your transactions",
    view_reward_bonus_schedule: "View Reward and Bonus Schedule",
    view_status: "View status",
    view_status: "View entire history",
    voting_info_1:
      "It's time to vote for 2 cryptocurrencies to add (or keep) as part of the BLUE basket for the first quarter (Q1) of 2023.",
    voting_info_2:
      "Lately, government regulators are pursuing cryptocurrency companies that offer returns on arbitrage and similar activities. Compliance to regulators would result in compromising the privacy of our users. As you know, here at Stratum, our user privacy and security have always been our main priority. We decided then, to remove such activities from our portfolio to avoid compliance, and base BLUE on the value of 14 cryptocurrencies instead of 12.",
    voting_info_3:
      "Simply click on the button below, and select 2 cryptocurrencies. Voting is not mandatory, but encouraged. We believe any of the options given will be a promising addition to the basket. We will count the votes according to the number of BLUE on your account (each full BLUE on your account gives you 1 vote). Voting will be available until December 30th 23:59h (UTC -3).",
    voting_info_4:
      "We will add more details about this change in an updated whitepaper on our website, such as voting frequency, and its future implementation using blockchain.",
    vote_bellow: "Vote below",
    vote_success: "Voted successfully, Thank you!",
    voting_survey: "Voting Survey",
    verify_step: "Verify your Redemption",
    view_other_currencies: "View other currencies",
    verify_your_withdraw: "Verify your withdrawal",

    //w
    waiting: `Processing`,
    welcome: "Welcome",
    with: "with",
    withdrawal: "Withdrawal",
    withdraw: "Withdraw",
    withdraws: "Withdraws",
    withdraw_amount: "Withdraw Amount",
    withdraw_transfer: "Withdraw",
    was_referred:
      "Ask your friend for his referral code to earn rewards, or leave blank to donate to Bitgive and B4H",
    waiting_for_aprove: "In Order",
    waiting_aprove_info: "Available funds only 60 days after each purchase",
    w: "W",
    withdraw_sub: `Withdrawal is an operation that allows you to send BLUE to a valid and compatible BLUE wallet address.`,
    withdraw_sub_usdt: `Withdrawal is an operation that allows you to send USDT to a valid
    and compatible USDT wallet address.`,

    withdraw_network_fee: "For withdraws exist the network fee of 0.0005 btc",
    we_accet: "We accept",
    why_change: "Why the change",
    white_paper: "White Paper",
    withdrawal_steps: "Withdrawal steps",
    withdrawing: "Withdrawing",

    //y
    yes_cancel_purchase: "Yes, I want to cancel",
    you_will_receive: "You will receive",
    your_email_shortly: "Your Email should arrive shortly",
    you_want_start_new_purchase:
      "You are canceling a deposit order. If you want to place a new one, start the purchase flow again.",
    you_must_accpet_terms:
      "You must agree to our terms and conditions to continue. If you have any questions, please contact support@bluetoken.io.",
    you_must_accpet_privacy:
      "You must agree to our privacy policy to continue. If you have any questions, please contact support@bluetoken.io.",
    yes: "Yes",
    //newBuyTexts
    beforeSendUnderTitle: `Select amount of BLUE you wish to purchase. The payment must be made with crypto.`,
    blockMsgP: `Minting of new tokens is temporarily unavailable.`,
    amount_in: "Amount in",
    estimated_amount_in: "Estimated amount in",
    important: "important",
    below_button_1: `- The amount of BLUE to credit depends on the amount of crypto we receive. Be aware of any fees your wallet provider might charge you for the transfer. Such charges will decrease the amount of crypto thus decreasing also the amount of tokens.`,
    below_button_2: `- If the amount of BTC we receive is below the minimum required (0.0208 BTC), your BTC will be added to a temporary balance, which you can use on a new order. `,
    understand_and_agree: `I understand that any amount above the minimum sent to our payment address will be converted to BLUE automatically. `,
    i_understand: "I understand",
    understand_and_agree_button: `I understand and Agree`,
    understand_and_agree_warning: `Purchase time is between 9am and 5pm (GMT-3), monday to friday. Transactions made outside that time period will be processed in the day after.`,
    waiting_deposit: `Waiting for deposit`,
    waiting_deposit_otc: `Waiting for OTC confirmation`,
    transaction_details: `transaction details`,
    transaction_failed_1: `transaction failed at step `,
    transaction_failed_2: `if you have any questions please contact support at support@bluetoken.io`,
    temporary_balance: `Temporary balance`,
    temporary_balance_substracted: `This temporary balance is subtracted from the total amount to send.`,
    to_send: `to Send`,
    to_receive: `to Receive`,
    received: `Received`,
    expected: `expected`,
    expected_amount_in: `Expected amount in`,
    estimated_blu: `estimated BLUE`,
    estimated: `estimated`,
    waiting_deposit_undertext: `BLUE amount will be confirmed upon payment’s confirmation on the blockchain.`,
    processing_order: `Processing order`,
    confirmed_amoutn: `confirmed amount`,
    follow_transaction_text: `Follow the Transaction`,
    check_transaction_status: `Check the status of your operation`,
    new_operation: `New Operation`,
    order_created: `Order Created`,
    confirmed_on_blockchain: `Confirmed on the blockchain`,
    order_completed: `Order Completed`,
    order_completed_info:
      "Your BLUE is being created, you will receive a certificate by e-mail when the process is completed.",
    order_completed_info_title: "Done",
    temporary_balance_warning: `Please keep in mind that you have a temporary Balance
        from previous transactions which will be added to your transfer.`,
    send_btc_to_address: `Send your {coin} to this address in order to receive your BLUES`,
    purchase_confirmation: `Purchase Confirmation`,
    min: `min`,
    btc_sent: "BTC Confirmed",
    blu_confirmed: `BLUE Confirmed`,
    minimum_amount_required: `The amount must be above the minimum.`,
    check_open_orders: `verify open order`,
    make_new_order: `make new order`,
    if_no_order: `If no order shows for a long period of time, please make sure you made an order. If needed, make a new one.`,
    confirmed: "Confirmed",
    waiting: "Waiting",
    action_blocked_purchase: `Our system is currently under maintenance, please try your purchase at a later time.`,
    bktc_text: "Bank to Crypto allows you to quickly buy Bitcoin.",
    bktc_text2: "To proceed with your transaction, pay with Fiat below",
    bktc_only_brazil: `Please beware that this method of payment should only be used by Brazilian customers.`,
    info_link_stratum_wallet: "Access your SmartWallet to buy crypto.",
    select_coin_payment: "Select a Payment Method",

    //other long phrases
    your_id_is: `Your ID is the 6 digits ID  code sent to your email upon signup.`,
    amount_too_small: "Amount is too small. Minimum purchase is 100 TUSD.",
    aware_token_redeem:
      "I am aware tokens may not be transferred until 60 days after purchase.",
    click_here_phases: "Click here for more details on each phase",
    create_new_email_recommendation: `We recommend that you create a new e-mail for each platform.  <span class="text_highlight"> This email will be used to receive your login information and other internal communication.</span>`,
    current_presale_ends: "Current Pre-Sale Phase 3 ends April 6",
    did_someone_referred: "Did someone refer you? (Optional)",
    i_read_and_accept:
      'I have read and accept the <a href="/terms" class="dis_inb main_white_fill main_white_fill_hover underline" target="_blank">Terms & Conditions</a> and <a href="/privacy" class="dis_inb main_white_fill main_white_fill_hover underline" target="_blank">Privacy Policy</a>.',
    // i_read_and_accept_policy:
    //   'I have read and accept the <a href="/privacy" class="dis_inb main_white_fill main_white_fill_hover underline" target="_blank">Privacy Policy</a>.',
    i_read: "I have read and accept the Terms & Conditions.",
    i_read_privacy: "I have read and accept the Privacy Policy.",
    not_usa_citizen: `I declare that I am not a citizen or resident of the United States of America.`,
    not_china_citizen: `I declare that I am not a citizen or resident of Hong Kong.`,
    scan_qr_code_or_copy_address: "Scan QR code or copy the address.",
    warning_60days:
      "Redemptions and withdraws are not available until 60 days after purchase. Do not send payment if you don't intend to purchase tokens.",

    //portfolio
    portfolio_intro: `Our crypto-basket is made from a selected pool of cryptocurrencies which have verifiable market trust or great growth potential.`,
    text_LUNA:
      "Terra is a blockchain protocol that uses fiat-pegged stablecoins to power price-stable global payments systems.",
    text_BTC:
      "Cryptocurrency with the largest market capitalization. Used for payments and store of value.",
    text_ETH:
      "First cryptocurrency platform to create smart contracts and decentralized applications.",
    text_XRP:
      "XRP is used by banks and companies for liquidity and transfer settlements.",
    text_LTC:
      "Known as the silver to Bitcoins gold. In the early days of crypto, Litecoin was created to be a faster, less expensive version of Bitcoin.",
    text_BCH:
      "Bitcoin Cash was created from a Bitcoin fork (coin split). It is a modified version of Bitcoin pursuing faster, less expensive transactions.",
    text_EOS:
      "Platform to build decentralized applications, with no transaction fees.",
    text_XLM:
      "Lumens are used for remittances, allowing settlements between different currencies.",
    text_ADA:
      "Project aiming to develop the most advanced smart contract platform. Its team consists of a large global collective of expert engineers and researchers, including Charles Hoskinson, co-founder of Ethereum.",
    text_BNB:
      "Digital Token created by the trading platform Binance, providing several benefits to its traders.",
    text_TRX:
      "Decentralized platform to share and monetize digital entertainment.",
    text_ZCR:
      "Cryptocurrency created for simplified payments. Services using Zcore include a mobile messenger and masternode system.",
    text_NXS:
      "Nexus advanced blockchain architecture provides the highest scalability and security. Nexus also aims to descentralize the internet by providing access via satellites in space.",
    text_IOTA:
      "The IOTA project aims to create a secure and decentralized financial ecosystem for the Internet of Things (IoT).",
    text_XMR:
      "Monero excels in privacy and untraceability. Transactions cannot be linked to a particular user or real-world identity.",
    text_OTC:
      "Cryptos currently include SafeInsure (SINS), Zcore (ZCR), SmartCash (SMART), DashGreen (DASHG), BitTorrent(BTT), Wink (WIN) and Bitcoin (BTC) .",
    text_DASH:
      "One of the best known cryptocurrencies with a vast growing network of users. Present since the earliest days of crypto, Dash focuses on fast secure payments.",
    text_LINK:
      "Ethereum token that powers the Chainlink decentralized oracle network, allowing smart contracts to securely connect to external data sources, APIs, and payment systems.",
    text_ALGO:
      "Led by Turing award-winner Silvio Micali, Algorand is an innovative blockchain which cannot be forked, thus avoiding double spending issues. It is used for decentralized exchanges, digital securities, and assets tokenization.",
    text_MKR:
      "Digital token created by MakerDAO, the largest decentralized finance platform, providing collateralized loans backed by Ethereum.",
    text_XTZ:
      "Native ryptocurrency of the Tezos blockchain,  which focuses on integrating smart contract technology with financial products.",
    text_LEND:
      "Digital token used at Aave, one of the fastest growing DeFi lending platforms, providing great benefits to their users.",
    text_DOT:
      "Polkadot aims to facilitate a fully functional and user-friendly decentralized web (Web 3.0), enabling cross-blockchain transfers of any type of data or asset.",
    text_UNI:
      "Governance token of Uniswap, one of the largest decentralized trading platforms hosted in Ethereum,  which facilitates trading of decentralized finance (DeFi) tokens.",
    text_FIL:
      "Filecoin is a decentralized storage system. Unlike cloud storage companies like Amazon or Cloudflare, Filecoin leverages its decentralized nature to protect data's integrity.",
    text_THETA:
      "Theta is the native cryptocurrency of the Theta Network, a blockchain for improving the quality and deliverability of streaming video content.",
    text_MANA:
      "Digital token used at Decentraland, a virtual reality platform, allowing users to purchase, customize and sell virtual parcels of land as NFTs.",
    text_CAKE:
      "Governance token of PancakeSwap, the fastest growing decentralized trading platform (DEX) hosted in the Binance Smart Chain.",
    text_MATIC: `Governance token of Polygon, a second layer network for Ethereum's scaling and infrastructure development. With Polygon, Ethereum becomes a multi-chain system, facilitating blockchain interoperability, with faster transactions at a lower cost.`,
    text_SOL:
      "Native token of the Solana network, a fast growing blockchain in the DeFi space, with superb speed and scalability, able to reach up to 65,000 transactions per second.",
    text_CRV:
      "Native token of Curve Finance, the decentralized exchange (DEX) with the current highest volume in DeFi. Curve Finance is unique due to its optimization for low slippage swaps between stablecoins or similar assets that peg to the same value.",
    text_AVAX:
      "Native token of Avalanche, an up-and-coming smart contracts blockchain in DeFi and the NFT space.",
    text_MBOX:
      "Governance token at Mobox, a decentralized play-to-earn gaming app, allowing users to trade NFTs and get rewarded by their participation.",
    text_USDT: "Stablecoin pegged to the American dollar.",
    text_TUSD: "Stablecoin pegged to the American dollar.",

    //charity text
    bitgive_info:
      "Using bitcoin and blockchain technology to improve public health and the environment worldwide.",
    b4h_info:
      "Supports organizations using blockchain technology to bring a positive change to humanity.",

    //tooltip
    tooltip_text_charity:
      "Up to 50% of our sales fees are donated to Bitgive and Blockchain for Humanity.",
    tooltip_purchase_referral:
      "You may fill this field if someone assisted you with the purchase.",
    tooltip_internal_withdraw: "This is the BLUE user ID of the recipient.",

    //redeem
    current_balance: `Current Balance`,
    unlocked_balance: `Unlocked balance`,
    total_without_fees: `Total without Fees`,
    total_to_receive: `Total to Receive`,

    min_length: `Minimum length is`,
    characters: `characters`,
    contact_intro: `If you have any questions or issues you need to solve please get in touch in the form below`,
    email_to_registered: `The email will be sent to your registered email in the platform`,
    subject: `subject`,
    message: `message`,
    form_sent: `Message sent successfully`,
    form_error: `There was an error sending your message, please try again`,
    insufficient_funds: `Insufficient Funds`,

    //modal voting coins
    coin_voting_enj:
      'Digital Token used at the ENJIN network, a social gaming platform, allowing users to monetize in-game items, such as NFTs. <a href="https://enjin.io/" target="_blank">Learn more</a>',
    coin_voting_mana:
      'Digital token used at Decentraland, a virtual reality platform, allowing users to purchase, customize and sell virtual parcels of land as NFTs. <a href="https://decentraland.org/" target="_blank">Learn more</a>',
    coin_voting_bat:
      'Digital token used to reward users and publishers in the growing "Brave" browser. Publishers and creators earn ad revenue as well as tips, while users maintain privacy as they earn BAT for viewing ads. <a href="https://basicattentiontoken.org/" target="_blank">Learn more</a>',
    coin_voting_dash:
      'One of the best known cryptocurrencies with a vast growing network of users. Dash focuses on fast and private payments, offering "PrivateSend" to activate untraceable transactions. <a href="https://www.dash.org/" target="_blank">Learn more</a>',
    coin_voting_mkr:
      'Digital token created by MakerDAO, one of the largest DeFi platforms, providing collateralized loans backed by Ethereum. <a href="https://makerdao.com/en/" target="_blank">Learn more</a>',
    coin_voting_xtz:
      'Native cryptocurrency of the Tezos blockchain,  which focuses on integrating Smart Contract technology with financial products. Lately, several NFT projects, such as the Cleveland Cavaliers, and McLaren, are using Tezos for their collections. <a href="https://tezos.com/" target="_blank">Learn more</a>',
    coin_voting_lend:
      'Digital token used at Aave, one of the fastest growing DeFi lending platforms, providing great benefits to AAVE users. <a href="https://aave.com/" target="_blank">Learn more</a>',
    coin_voting_atom:
      'Fast growing ecosystem of blockchains that can scale and interoperate with each other, competitor to Polkadot (DOT), Ethereum (ETH) and other major smart contract cryptocurrencies. <a href="https://cosmos.network/" target="_blank">Learn more</a>',
    coin_voting_band:
      'Cross-chain data oracle platform that aggregates and connects real-world data and APIs to smart contracts. <a href="https://bandprotocol.com/" target="_blank">Learn more</a>',
    coin_voting_aave:
      'Digital token used at AAVE, one of the largest DeFi lending platforms. AAVE has recently upgraded to version 3.0, providing "cross-chain" lending and new mechanisms to improve user experience, risk management and capital efficiency. <a href="https://aave.com/" target="blank_">Learn more</a>.',
    coin_voting_uni:
      'One of the best known decentralized trading platforms, facilitating automated trading of decentralized finance (DeFi) tokens. <a href="https://uniswap.org/" target="blank_">Learn more</a>.',
    coin_voting_fil:
      'Filecoin is a decentralized storage system. Unlike cloud storage companies like Amazon or Cloudflare, Filecoin leverages its decentralized nature to protect data integrity. <a href="https://filecoin.io/" target="blank_">Learn more</a>.',
    coin_voting_cake:
      'Governance token of PancakeSwap, the fastest growing decentralized trading platform hosted in the Binance Smart Chain. <a href="https://pancakeswap.finance/" target="blank_">Learn more</a>.',
    coin_voting_matic: `Governance token of Polygon, a second layer network for Ethereum's scaling and infrastructure development. With Polygon, Ethereum becomes a multi-chain system, facilitating blockchain interoperability, with faster transactions at a lower cost. <a href="https://polygon.technology/" target="blank_">Learn more</a>.`,
    coin_voting_sand: `Governance token of The Sanbox, a virtual reality world where people can create, share, and sell content as NFTs, such as games and unique experiencies. <a href="https://sandbox.game/" target="blank_">Learn more</a>.`,
    coin_voting_axs: `Governance token of Axie Infinity, the fastest growing "play-to-earn" virtual reality game using NFTs. Over 1 million daily active players "battle" in Axie Infinity for the chance to earn crypto rewards. <a href="https://axieinfinity.com/" target="blank_">Learn more</a>.`,
    coin_voting_mbox: `Governance token at Mobox, a decentralized play-to-earn gaming app, allowing users to trade NFTs and get rewarded by their participation. <a href="https://www.mobox.io/#/" target="blank_">Learn more</a>.`,
    coin_voting_xmr: `Cryptocurrency focused in privacy. Monero was designed to avoid censorship, with its transactions being fully untraceable. <a href="https://monero.org" target="blank_">Learn more</a>.`,
    coin_voting_egld: `Elrond is a blockchain designed for high throughput and fast execution speed compared to other smart contract platforms. In order to increase adoption, the project supports developers building on the platform, allowing them to earn 30% of the smart contract fees as royalties. <a href="https://elrond.com/" target="blank_">Learn more</a>.`,
    coin_voting_etc: `Ethereum Classic is the original Ethereum, which still runs with Proof of Work (miners). ETC is used to pay for executing transactions and smart contract functions. <a href="https://ethereumclassic.org/" target="blank_">Learn more</a>.`,
    coin_voting_ton: `Toncoin (TON) is a decentralized layer-1 blockchain developed in 2018 by the encrypted messaging platform Telegram. The project was then abandoned, taken over by the TON Foundation, and renamed from "Telegram Open Network" to "The Open Network". <a href="https://ton.org/" target="blank_">Learn more</a>.`,
    coin_voting_xlm: `Stellar is an open-source payments network that serves as a distributed intermediary blockchain for global financial systems and circulates a native asset, Stellar Lumens (XLM). <a href="https://stellar.org/" target="blank_">Learn more</a>.`,

    modalNetwork: {
      title: "Announcements",
      text_one: `We are glad to inform you we recently added new features:`,

      title_two: "Blue Club",
      text_two: `A Blue Club membership NFT is given to users who purchase 20 BLUE tokens or more. Blue Club members enjoy the following benefits:`,
      text_two_t: `You may follow your qualification progress on your Dashboard. We look forward to welcoming you to Blue Club!`,
      title_three: "Tether Wallets",
      text_three:
        "You may now deposit and withdraw Tether (USDT), giving you more investment flexibility. Decide whether is a good time to buy and hold Blue Tokens, or keep Tether at your wallet for when the time is right."
    },

    modalBscInfo: {
      title: "Announcements",
      text_one: `As previously informed on our quarterly reports, BLUE will be switching blockchains. The BLUE token will leave the NEM blockchain, to be hosted in the Binance Smart Chain (BSC) blockchain.`,

      text_two: `The move has been scheduled for Thursday, November 11th, 2021 at 9:00h (UTC-3). The platform will be unavailable during this transition, which is expected to be 4 days. We expect to have the platform up and running again on Monday, November 15th. During this time, all operations will be unavailable, so please plan accordingly.`,

      title_two: "The token price and users balance will not be affected.",
      text_three:
        "Users will have the same amount of tokens they had before the move. The price of the token will continue to track the 14 cryptocurrencies in our basket during this period.",
      title_four:
        "We are very excited about the move. BSC will allow easier integration of BLUE with third parties wishing to work with the token. BSC is growing rapidly, currently being the second largest blockchain used on DeFi applications. Due to its low fees, developers and users regard BSC as a cheaper alternative to Ethereum. In addition, BSC was built to host Ethereum projects, which is why developers find it easy to host their projects in Ethereum and BSC.",
      title_five:
        "As promised, we are constantly working to grow BLUE. This move is a very important step towards our expansion. We are thankful to all our users who continue to support the project."
    },

    modalBluePool: {
      title: "Announcements",
      text_one: `We have updated our terms and conditions.`,
      title_one: "Purchase fee",
      text_two: `We lowered the BLUE token purchase fee, from 6% to 2%. This will reduce costs to people who wish to purchase BLUE tokens for the first time, and those who usually do monthly contributions.`,
      title_two: "Custodial fee",
      text_three:
        "We raised our custodial fee, from 2.5% to 6% (annual). This will allow us to provide you with better tools, service, and security, plus the creation of a new rewards system.",
      title_four: "New Rewards System: Blue Pool",
      text_four:
        "We are introducing a new rewards system: Blue Pool. All users are now able to participate in a monthly rewards pool. Rewards are paid to users who refer their friends to purchase BLUE tokens. The first pool has been set at 4.20 BLUE (approximately $1,800 dollars). Earn your share!"
    },

    modalDhbtInfo: {
      title: "Announcements",
      text_one: `We have updated our terms and conditions.`,
      text_two: `As previously announced, Blue Token is now a product of a newly formed company, Digital Horizon Blockchain Technology, registered in the country of El Salvador.`,

      title_two:
        "The move was due to several benefits given by El Salvador to crypto businesses. El Salvador is the only country in the world that has accepted Bitcoin as legal tender. Its government is incentivizing crypto businesses to invest and flourish, preparing the foundation for future growth in technological innovation and infrastructure.",
      text_three:
        "We are very excited about the move, and are ready to take advantage of the benefits of El Salvador to take Blue Token to the next level.",
      title_four:
        "If you have any questions, please email us at support@bluetoken.io.",
      title_one: "Blue is a product of Digital Horizon, based at El Salvador",
      title_five: "Redemption payments and fees",
      text_four:
        "Starting in February 2nd, all redemptions will be paid out only in USDT (Tether), along with redemptions fees changes:",
      text_six: `Redemption fee: 1% of redemption amount <br/>Minimum redemption fee: 50 USDT`,
      text_seven:
        "Time of payment will continue to be 3 business days. Users will have to option for same-day payment for a fee."
    },

    modalBuyBluePix: {
      buy_blue: "Buy BLUE",
      connecting_swapix: "Connecting to SWAPiX",
      only_accepts: "Blue Token only accepts payment in cryptocurrencies.",
      pix_purcase_processed:
        "Fortunately, Pix purchases are processed by our trusted partner SWAPiX.",
      swapix_terms:
        "I have read SWAPiX <a class=p5_l href=https://usdt.smartpay.com.vc/static/media/terms_jun.f681a88b.pdf target=blank>terms and conditions</a>.",
      btn_next: "Next",
      welcome: "Welcome to",
      payment_being_processed: "Your payment information is being processed.",
      wait: "Wait a few seconds while we work our magic…",
      payment: "Payment",
      convert_price: "Exchange rate",
      completed_buy:
        "Your purchase has been completed. If your balance is not up to date, please refresh the page."
    },

    modalWarnUser: {
      title: "Withdraw: Important",
      warn1:
        "Make sure the receiving wallet supports BLUE tokens. Not all BSC wallets support BLUE.",
      warn2:
        "Blue Token does not assume responsibility for operations occurring on third party platforms.",
      warn3: "All transactions originating outside our platform incur 6% fee.",
      warn4:
        "Withdrawals are irreversible. Make sure you are sending your tokens to a trusted party.",
      i_understand: "I understand"
    },

    modalBlueClub: {
      title: "Membership Benefits",
      subTitle:
        "A Blue Club membership NFT is given to users who purchase 20 tokens or more.",
      text1: `<div style="display:flex"><a href="https://solscan.io/token/AP9rP81KJzPCQFmE4fK9Ue8NWRaXZ5QbqQJn6PKhQP17" target="_blank" style="color: #cb36ee; text-decoration:underline; margin-right:5px">Blue Club NFT</a> (Non-fungible token).</div>`,
      text2:
        "Priority / VIP access to all our events, including gifts and souvenirs.",
      text3: "Exclusive consulting services.",
      text4: "Rewards from our partners (airdrops, giveaways, promotions).",
      text5: "Invitation to exclusive networking events."
    },

    modalClainBlueClub: {
      title: "Claim your Blue Club NFT",
      text2: "Congratulations! You now belong to Blue Token's select VIP club.",
      text3:
        "You must now claim your NFT, which will give you access to several membership benefits.",
      text4: "Input you Solana Address:",
      text5: "Use an Exodus or Phantom wallet to store your NFT.",
      text6: "For any questions, please contact our support team.",

      text7: "Welcome to Blue Club!",
      text8:
        "Your NFT is being created. You will receive it within 2 business days.",
      text9:
        "You will receive a welcome email. Please make sure is not in your spam, since we will keep you posted on events and services in which you will receive VIP treatment.",
      text10: "ok, great!"
    },

    settings: {
      title: "Account Settings",
      profile: "Profile",
      security: "Security",
      notifications: "Notifications",

      updateInfoProfile: "Update your basic profile information.",
      updateInfoSecurity: "Update your basic security information.",
      updateInfoNotifications: "Disable or enable your email notifications.",

      currently: "Currently",
      profileStatus: "Profile Status",

      updateProfile: "Click on Save to update your profile information.",
      updateSecurity: "Click on Save to update your security information.",
      updateNotification: "Click on Save to update your notification settings.",

      toggleEmail: "Toggle your email notifications",

      popupSure: "Are you sure?",

      popupChangesApply: "Changes will apply when you log back in."
    }
  }
};



// WEBPACK FOOTER //
// ./src/lang/en.js